<template>
  <el-dialog :title="title" :visible.sync="setShow" width="28%" @close="cancel">
    <el-form :model="form" label-position="top" ref="form" @submit.prevent>
      <el-row type="flex">
        <el-col :span="24">
          <member-role-input :roles.sync="form.roles" />
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button plain size="medium" @click="cancel">Cancel</el-button>
      <el-button
        type="primary"
        size="medium"
        :loading="changing"
        @click="changeRole"
        >Change</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import MemberRoleInput from "@/components/Organisation/Members/MemberRoleInput.vue";

export default {
  name: "OrganisationMemberRoleChange",
  components: { MemberRoleInput },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    member: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      changing: false,
      form: {
        roles: []
      }
    };
  },
  computed: {
    title() {
      const user = this.member.account_user;
      return `Change Role for ${user.first_name} ${user.last_name}`;
    },
    setShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      }
    }
  },
  watch: {
    show() {
      if (this.show) {
        this.setRoles();
      }
    }
  },
  created() {
    this.setRoles();
  },
  methods: {
    cancel() {
      this.form = {
        roles: []
      };
      this.setShow = false;
    },
    setRoles() {
      const roles = this.member.user_roles;
      this.form.roles =
        roles && roles.length ? roles.map(role => role.role_id) : [];
    },
    changeRole() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return false;
        }
        const { organisation_id: organisationId, account_user } = this.member;
        const userId = account_user && account_user.id;

        this.changing = true;
        this.$http
          .post(
            `organisations/${organisationId}/accounts/users/${userId}/roles`,
            {
              body: this.form,
              method: "PUT"
            }
          )
          .then(response => {
            const resData = response.data;
            if (resData.status === "error") {
              this.handleErrors(resData);
              this.changing = false;
            } else {
              this.notification(
                "Completed",
                "Role changed successfully",
                "success"
              );
              this.changing = false;
              this.$emit("updated");
              this.cancel();
            }
          })
          .catch(() => {
            this.notification("Error", "An unknown error occurred", "danger");
            this.changing = false;
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
